import React from 'react';
import { Box, Typography, Checkbox } from 'vindi-ds-components';
import PriceRangeInput from './price_range_input';
import { priceRangeErrorStyle } from '../styles';
import PriceRangeErrorsAlert from './priceRangeErrorAlert';

function PriceRange({ type, priceRangeErrors }) {
  return (
    <>
      <Box mb='1em'>
        <Typography variant='body2' component='h3'>Faixas de preço</Typography>
      </Box>
      <PriceRangeInput type={type} />
      <PriceRangeErrorsAlert
        style={priceRangeErrorStyle}
        title='Erros da faixa de preço'
        errors={priceRangeErrors}
      />
      <Box mt='1em'>
        <Checkbox label='Não definir término' />
      </Box>
    </>
  );
}

export default PriceRange;
